var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2.75 2.75h16.5v16.5H2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73 9.503v7.652c0 .524-.367.95-.82.95H6.09c-.453 0-.82-.426-.82-.95V5.762c0-.524.367-.95.82-.95H11",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46 3.587a.65.65 0 0 1 0 .919l-5.194 5.193a.344.344 0 0 1-.123.08l-1.216.454a.137.137 0 0 1-.174-.185l.503-1.12a.344.344 0 0 1 .07-.102l5.215-5.238a.649.649 0 0 1 .918-.001Z",
    fill: "currentColor"
  }))));
};
export default SvgEdit;